import { useCallback } from "react";
import type { Engine } from "tsparticles-engine";
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim";
import styles from "./SnowAnimation.module.scss";
import classNames from "classnames";
interface SnowAnimationProps {
  hasAnimation?: boolean;
}

const SnowAnimation: React.FC<SnowAnimationProps> = ({ hasAnimation }) => {
  const particlesInit = useCallback(async (engine: Engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div className={classNames(styles.snowAnimation)}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fpsLimit: 120,
          particles: {
            move: {
              direction: "bottom-right",
              enable: true,
              outModes: {
                default: hasAnimation ? "out" : "destroy",
              },
              speed: { min: 4, max: 6 },
            },
            number: {
              value: hasAnimation ? 160 : 5,
            },
            size: {
              value: { min: 4, max: 9 },
            },
            shape: {
              type: "circle",
            },
          },
          detectRetina: true,
          smooth: true,
        }}
      />
    </div>
  );
};

export default SnowAnimation;
